import { TextCounter } from "$lib/core";
import { FormRestructureEvent } from "../core/";
import { validationServiceInstance } from "./service";

let added = false;

/**
 * @param {HTMLFormElement} form 
 */
export function addTextCounterValidation(form) {
	form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

		for (const entry of event.added) {
			if (!entry.field) continue;

			/** @type {NodeListOf<HTMLInputElement|HTMLTextAreaElement>} */	
			const elements = entry.field.querySelectorAll(`:scope :is(input,textarea)[data-once="webform-counter"]`);
		}
	});

	if (!added) {
		added = true;
		validationServiceInstance.addProvider("textcounter", textCounterValidationProvider);
	}
}

/**
 * @type {import("aspnet-client-validation").ValidationProvider}
 */
export const textCounterValidationProvider = (value, element, params) => {
	if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLTextAreaElement)) return true;
	if (!element.dataset.once?.includes("webform-counter")) return true;
	if (!element.dataset.valTextcounter) return true;
	const textCounter = "textcounter" in element ? /** @type {TextCounter} */ (element.textcounter) : null;
	return textCounter?.errorText ?? true;
}
